<template lang='pug'>
#app(data-app)
  loading(ref='loading', @interrupt='$emit("interrupt")')
  app-frame(ref='frame', @showMenu='dialogMenu = true')
    router-view(v-if='ready')
  number-input-modal(ref='numberInput')
  v-dialog(v-model='dialogMenu', fullscreen, transition='slide-x-reverse-transition')
    app-menu(@close='dialogMenu = false', @goto='go', @logout='onClickLogout', :items='menuItems')
  confirm(ref='confirm')
</template>

<script>
import AppFrame from './components/appFrame'
import NumberInputModal from '@/components/productionStatus/numberInputModal'
import AppMenu from '@/components/menu'
import api from '@/api'
import lodash from 'lodash'
import { mapActions, mapState, mapMutations } from 'vuex'
import Confirm from '@/components/ui/confirm'
import loading from '@/components/ui/loading'

export default {
  computed: { ...mapState(['settings', 'user']) },
  components: { AppFrame, NumberInputModal, AppMenu, Confirm, loading },
  name: 'App',
  async created () {
    this.loadToken()
    api.setToken(this.user.token)
    window.App = this
    await this.loadSiteConfig()
    this.$root.$showLoading()
    try {
      await this.tryToLoadSetting()
      await this.loadLogged()
    } catch (e) {
      this.$router.push('/Login')
    }
    this.$root.$hideLoading()
    this.ready = true
    this.initErrorHandler()
  },
  mounted () {
    this.$root.$confirm = this.$refs.confirm.open
    this.$root.$showLoading = this.$refs.loading.show
    this.$root.$hideLoading = this.$refs.loading.hide
  },
  data: () => ({
    ready: false,
    dialogMenu: false,
    menuItems: [
      {label: 'Main', icon: 'home', href: '/Main'},
      {label: 'Production Status', icon: 'bar', href: '/ProductionStatus'},
      {
        label: 'Check Sheet',
        icon: 'doc',
        extended: false,
        children: [
          {label: 'Plan', href: '/CheckSheet/Plan'},
          {label: 'Equipment', href: '/CheckSheet/Equipment'},
          {label: 'Compressor', href: '/CheckSheet/Compressor'},
          {label: 'Transformer', href: '/CheckSheet/Transformer'},
          {label: 'AHU', href: '/CheckSheet/AHU'},
          {label: 'Boiler', href: '/CheckSheet/Boiler'},
          {label: 'Dust Collector', href: '/CheckSheet/DustCollector'}
        ]
      },
      {
        label: 'Work Report',
        icon: 'doc',
        extended: false,
        children: [
          {label: 'Daily report', href: '/WorkReport/Daily'},
          {label: 'Repair report', href: '/WorkReport/Repair'}
        ]
      },
      {
        label: 'Schedule',
        icon: 'cal',
        extended: false,
        children: [
          {label: 'Monthly Schedule', href: '/Schedule/Monthly'}
          // {label: 'Daily Timetable', href: '/Schedule/Daily'}
        ]
      },
      {
        label: 'Equipment',
        icon: 'doc',
        extended: false,
        children: [
          {label: 'Ledger', href: '/Equipment/Ledger'},
          {label: 'Drawing', href: '/Equipment/Drawing'},
          {label: 'Equipment History', href: '/Equipment/RepairHistory'},
          // {label: 'PLC', href: '/Equipment/PLC'},
          {label: 'Software Program', href: '/Equipment/Software'},
          {label: 'Parameter', href: '/Equipment/Parameter'},
          {label: 'Maintenance Guide', href: '/Equipment/MaintenanceGuide'},
          {label: 'Trouble Shooting', href: '/Equipment/TroubleHistory'},
          {label: 'Setting Guide', href: '/Equipment/SettingGuide'},
          {label: 'Manual', href: '/Equipment/Manual'},
          {label: 'Contact Supplier', href: '/Equipment/Contact'}
        ]
      },
      {
        label: 'Spare Part',
        icon: 'doc',
        extended: false,
        children: [
          {label: 'Spare List', href: '/SparePart/Spare'},
          {label: 'Need Purchase', href: '/SparePart/NeedPurchase'}
          // {label: 'Stocktaking', href: '/SparePart/Stocktaking'}
        ]
      },
      {
        label: 'Manufacturing&Repair Request',
        icon: 'chat',
        extended: false,
        children: [
          {label: 'Repair Request', href: '/repairRequest/result'},
          {label: 'Repair finish', href: '/repairRequest/finish'}
        ]
      },
      {
        label: 'Request Offer',
        icon: 'help',
        extended: false,
        children: [
          {label: 'Offer List', href: '/RequestOffer/Offer'},
          {label: 'Company Registration', href: '/RequestOffer/Registration'}
        ]
      },
      {
        label: 'Beacon',
        icon: 'doc',
        href: '/beacon'
      },
      {label: 'KPI', icon: 'bar', href: '/KPI'},
      {label: 'Administration', icon: 'doc', href: '/admin'}
    ]
  }),
  methods: {
    ...mapActions({
      'loadSettings': 'settings/load',
      'initLines': 'productionStatus/initLines',
      'loadLogged': 'user/load'
    }),
    ...mapMutations({
      'loadToken': 'user/loadToken',
      'removeToken': 'user/removeToken'
    }),
    frame () { return this.$refs.frame },
    initErrorHandler () {
      api.errorHandler = (e) => {
        console.log('err, ', e)
        if (e.toString().endsWith('401') || e.toString().endsWith('422')) {
          this.removeToken()
          api.setToken(null)
          document.location = '/'
        }
      }
    },
    async tryToLoadSetting () {
      await this.loadSettings()
      this.initLines(this.settings.data.lines)
    },
    async loadSiteConfig () {
      await this.$loadScript('/static/site/config.js')
      lodash.extend(api, (window.site_config || {api: {}}).api)
      console.log('loadSiteConfig, ', api.host_biz)
    },
    async showNumberInput () {
      return this.$refs.numberInput.show()
    },
    go (href) {
      this.dialogMenu = false
      if (this.$router.history.current.path === href) { return }
      this.$router.push(href)
    },
    onClickLogout () {
      this.dialogMenu = false
      this.removeToken()
      api.setToken(null)
      document.location = '/'
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap');
</style>

<style lang='less'>
@import '~@/assets/common.less';

html, body {
  height:100%; overflow:hidden;
  margin: 0px;
  touch-action: manipulation;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#app:extend(.full-screen, .absolute) {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue